import React from 'react'
import { Grid, Button } from '@material-ui/core'
import GolfCourseIcon from '@material-ui/icons/GolfCourse'

class Hero extends React.Component {
  componentDidMount () {
    setTimeout(() => {
      document.getElementById('hero').classList.add('transition')
    }, 0)
  }

  render () {
    return (
      <Grid container id='hero' className='hero-container'>
        <Grid className='left-area'>
          <GolfCourseIcon className='golf-icon' />
          <Grid>Suomen Golfliiton virallinen yhteistyökumppani</Grid>
        </Grid>
        <Grid item xs={12} className='text-area'>
          <h1>
            Nauti viheriöstä omalla pihallasi ympäri vuoden.
          </h1>
          <h2 className='hide-mobile'>
            Toteutamme golfunelmia. Takaamme sinulle ammattilaistason viheriön ympärivuotisesti.
          </h2>
          <Button className='link-button' href='#contact-form'>Ota yhteyttä</Button>
        </Grid>
      </Grid>
    )
  }
}

export default Hero
